import { EOriginalContractAvailability } from "../types/agreements.types";

export const OriginalContractAvailabilityValues: Record<
  EOriginalContractAvailability,
  string
> = {
  [EOriginalContractAvailability.ABSENT]: "Отсутствует",
  [EOriginalContractAvailability.IN_STOCK]: "В наличии",
  [EOriginalContractAvailability.WIHOUT_DOCUMENTS]: "Без документов",
};
